package com.nonopn.skywatcher.common.api

import io.ktor.client.HttpClient

class ApiNoSession(
    private val baseUrl: String,
    private val client: HttpClient
) {
    private val calls = DoNetworkCalls(
        client
    )

    suspend fun login(body: LoginRequest): APIUserSession = calls.post(
        "$baseUrl/login",
        body
    )

    suspend fun register(body: LoginRequest): APIUserSession = calls.post(
        "$baseUrl/register",
        body
    )
}
